import React from 'react';
import PropTypes from 'prop-types';

class RevertableForm extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    // Get out default values based on the section
    const { id = null } = nextProps.obj || {};

    // Using state.id to check if the section passed in is a different section
    if (prevState.id === undefined || prevState.id !== id) {
      return {
        ...prevState,
        id,
        origObj: { ...nextProps.obj },
      };
    }
    return null;
  }

  constructor(props) {
    super(props);
    this.state = { id: null, origObj: {}, newObj: { ...this.defaultNewObj } };
    this.handleChange = this.handleChange.bind(this);
    this.handleRevert = this.handleRevert.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
  }

  formatChangedValue(event) {
    return event.target.value;
  }

  handleChange(event) {
    if (event.target.name) {
      if (this.props.obj) {
        this.submit({
          ...this.props.obj,
          [event.target.name]: this.formatChangedValue(event),
        });
      } else {
        this.setState({
          newObj: { ...this.state.newObj, [event.target.name]: this.formatChangedValue(event) },
        });
      }
    }
  }

  submit(newObj) {
    this.props.onChange(newObj);
  }

  isDirty() {
    if (!this.state.origObj) return false;
    return (
      Object.keys(this.state.origObj).filter(name => !(name === 'id' || this.state.origObj[name] === this.props.obj[name])).length > 0
    );
  }

  handleRevert(e) {
    e.preventDefault();
    if (this.state.origObj && this.state.id) {
      this.submit(this.state.origObj);
    }
  }

  handleCreate(e) {
    e.preventDefault();
    this.props.onCreate(this.state.newObj);
  }

  getRevertButton() {
    if (this.props.obj) {
      const isDirty = this.isDirty();
      return (
        <a
          className={`card-link ${isDirty ? '' : 'text-muted'}`}
          href="#revert-changes"
          disabled={!isDirty}
          onClick={this.handleRevert}
        >
          Revert
        </a>
      );
    }
    return undefined;
  }

  getCreateButton() {
    if (!this.props.obj) {
      return (
        <button className="btn btn-success ml-auto" onClick={this.handleCreate}>
          Create
        </button>
      );
    }
    return undefined;
  }
  defaultNewObj = {};
}

RevertableForm.defaultProps = {
  obj: undefined,
  onChange: undefined,
};
RevertableForm.propTypes = {
  obj: PropTypes.shape({
    id: PropTypes.number,
  }),
  onChange: PropTypes.func,
};

export default RevertableForm;



// WEBPACK FOOTER //
// ./src/components/RevertableForm.js